module.exports = __webpack_public_path__ + "img/move27.68a1b47a.jpg";